<template>
  <div class="table-container">
    <table id="thistable">
      <thead>
        <tr>
          <th class="sticky-header">
            <h4 style="color:white; text-align: center;">
              <button @click="nextMonth(-1)"
                style="background: none; border: none; color: white; cursor: pointer; font-size: 1em;">
                &laquo;
              </button>
              {{ writeDateTitle() }}
              <button @click="nextMonth(1)"
                style="background: none; border: none; color: white; cursor: pointer; font-size: 1em;">
                &raquo;
              </button>
            </h4>

            <vs-button v-if="displayExport != false" @click="copyToClipboard('thistable')" style="width:100%;"
              class="mt-4">Copy Table</vs-button>
          </th>
          <th class="sticky-header" style="font-size: 85%">Total Incl. Lunch</th>
          <th class="sticky-header" style="font-size: 85%">Working Days</th>
          <th class="sticky-header" style="font-size: 85%">Total Worked</th>
          <th class="sticky-header" style="font-size: 85%; cursor: help" title="Concediu de odihnă">CO</th>
          <th class="sticky-header" style="font-size: 85%; cursor: help" title="Concediu medical">CM</th>
          <th class="sticky-header" style="font-size: 85%; cursor: help" title="Concediu legal">CL</th>
          <th class="sticky-header" style="font-size: 85%; cursor: help" title="Concediu fără plată">FP</th>
          <th class="sticky-header" style="font-size: 85%; cursor: help" title="Nemotivat">NM</th>
          <th class="sticky-header" v-for="n in 31" :key="n" style="font-size: 85%">
            <span v-if="isWeekEnd(n)" style="color: #ffe66a;">{{ n }} {{ writeDateTitle() }}</span>
            <span v-else>{{ n }} {{ writeDateTitle() }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(tr, indextrr) in operationsData" :key="indextrr" style="font-size: 100%">
          <td class="td_name sticky-column">{{ indextrr + 1 }}. {{ tr.name }}</td>
          <td class="td_sum">{{ formated_time_total(tr.sum_worked) }}</td>
          <td class="td_sum"><b>{{ (tr.nb_days_with_datestart) }}</b></td>
          <td class="td_sum"><b>{{ formated_time_total(tr.adjusted_sum_worked) }}</b></td>
          <td class="td_small" v-if="tr.nb_co == 0">-</td>
          <td class="td_small" v-else><b>{{ tr.nb_co }}</b></td>
          <td class="td_small" v-if="tr.nb_cm == 0">-</td>
          <td class="td_small" v-else><b>{{ tr.nb_cm }}</b></td>
          <td class="td_small" v-if="tr.nb_cl == 0">-</td>
          <td class="td_small" v-else><b>{{ tr.nb_cl }}</b></td>
          <td class="td_small" v-if="tr.nb_fp == 0">-</td>
          <td class="td_small" v-else><b>{{ tr.nb_fp }}</b></td>
          <td class="td_small" v-if="tr.nb_nm == 0">-</td>
          <td class="td_small" v-else><b>{{ tr.nb_nm }}</b></td>
          <td class="td_day" v-for="n in 31" :key="n">
            <span v-if="tr[`_${n}`] && isError(tr[`_${n}`])" class="likebtnred"
              :title="leaveFullName(tr[`_${n}`])"
              :style="leaveFullName(tr[`_${n}`]) ? 'cursor: help' : ''"
              @click="activePopup(tr, n, tr[`_${n}`])">{{ formated_time(tr[`_${n}`]) }}</span>
            <span v-else-if="tr[`_${n}`] && !isError(tr[`_${n}`])" class="likebtn" @click="activePopup(tr, n, null)">{{
              formated_time(tr[`_${n}`]) }}</span>
            <span v-else @click="activePopup(tr, n)" class="likebtngray"
              style="padding-left: 10px;padding-right: 10px;">+</span>
          </td>
        </tr>
      </tbody>
    </table>

    <vs-popup :title="OpenedPopupTitle" :active.sync="popupActive">
      <div class="vx-row" id="page-user-view">
        <div class="vx-col lg:w-6/12 w-full">
          <span class="px-2" style="font-size:12px">Concediu de odihnă</span>
          <vs-switch color="primary" color-off="danger" v-model="dataIsCO" style="width: 80px;"
            @change="allOffExceptSelected('dataIsCO')">
            <span slot="on">On</span>
            <span slot="off">Off</span>
          </vs-switch>

          <span class="px-2" style="font-size:12px">Concediu medical</span>
          <vs-switch color="primary" color-off="danger" v-model="dataIsCM" style="width: 80px;"
            @change="allOffExceptSelected('dataIsCM')">
            <span slot="on">On</span>
            <span slot="off">Off</span>
          </vs-switch>

          <span class="px-2" style="font-size:12px">Concediu legal</span>
          <vs-switch color="primary" color-off="danger" v-model="dataIsCL" style="width: 80px;"
            @change="allOffExceptSelected('dataIsCL')">
            <span slot="on">On</span>
            <span slot="off">Off</span>
          </vs-switch>
        </div>
        <div class="vx-col lg:w-6/12 w-full">
          <span class="px-2" style="font-size:12px">Concediu fără plată</span>
          <vs-switch color="primary" color-off="danger" v-model="dataIsFP" style="width: 80px;"
            @change="allOffExceptSelected('dataIsFP')">
            <span slot="on">On</span>
            <span slot="off">Off</span>
          </vs-switch>

          <span class="px-2" style="font-size:12px">Nemotivat</span>
          <vs-switch color="primary" color-off="danger" v-model="dataIsNM" style="width: 80px;"
            @change="allOffExceptSelected('dataIsNM')">
            <span slot="on">On</span>
            <span slot="off">Off</span>
          </vs-switch>
        </div>
      </div>
      <hr class="mt-4 mb-4" style="border: 1px dotted #bbb; border-style: none none dotted; ">
      <div class="vx-row items-end">
        <div class="vx-col">
          <span class="px-2" style="font-size:12px">Du</span><br>
          <flat-pickr style="width:140px" :config="configDateOnly" v-model="rangeStart" placeholder="Début" />
        </div>
        <div class="vx-col">
          <span class="px-2" style="font-size:12px">Au</span><br>
          <flat-pickr style="width:140px" :config="configDateOnly" v-model="rangeEnd" placeholder="Fin" />
        </div>
        <div class="vx-col">
          <vs-button color="warning" @click="saveRange()" :disabled="inprogress">Appliquer sur la période</vs-button>
        </div>
      </div>
      <hr class="mt-4 mb-4" style="border: 1px dotted #bbb; border-style: none none dotted; ">
      <div v-for="(to, index) in popupData" :key="index" class="mt-8">
        <span class="likebtnpopup"><flat-pickr style="width:170px" :config="configdateTimePicker" v-model="to.datestart"
            @input="changeDuration(to)" placeholder="Start" /></span>
        <span class="likebtnpopup"><flat-pickr style="width:170px" :config="configdateTimePicker" v-model="to.datestop"
            @input="changeDuration(to)" placeholder="Stop" /></span>
        <span class="likebtnpopupduration ml-2 mr-2">{{ to.duration }}</span>
        <span class="likebtnpopupduration">
          <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
            @click.stop="deleteClock(to.id)" /></span>

        <!-- Geolocation Information -->
        <div v-if="to.url_start || to.url_stop" class="mt-4 p-3" style="background: #f8f9fa; border-radius: 8px; border-left: 4px solid #007bff;">
          <h6 style="color: #007bff; margin-bottom: 10px;">
            <feather-icon icon="MapPinIcon" svgClasses="w-4 h-4 mr-1" />
            Geolocation Information
          </h6>

          <!-- START -->
          <div v-if="to.url_start" class="mb-3">
            <strong style="color: #28a745;">📍 Work Start:</strong>
            <div class="ml-3">
              <div style="font-size: 12px; color: #666;">
                <strong>Position:</strong>
                <a :href="to.url_start" target="_blank" style="color: #007bff; text-decoration: none;">
                  View on Google Maps
                </a>
              </div>
              <div v-if="to.accuracy_start" style="font-size: 12px; color: #666;">
                <strong>Accuracy:</strong> {{ to.accuracy_start }}
              </div>
            </div>
          </div>

          <!-- STOP -->
          <div v-if="to.url_stop">
            <strong style="color: #dc3545;">📍 Work End:</strong>
            <div class="ml-3">
              <div style="font-size: 12px; color: #666;">
                <strong>Position:</strong>
                <a :href="to.url_stop" target="_blank" style="color: #007bff; text-decoration: none;">
                  View on Google Maps
                </a>
              </div>
              <div v-if="to.accuracy_stop" style="font-size: 12px; color: #666;">
                <strong>Accuracy:</strong> {{ to.accuracy_stop }}
              </div>
            </div>
          </div>

          <!-- Message if no geolocation -->
          <div v-if="!to.url_start && !to.url_stop" style="font-size: 12px; color: #6c757d; font-style: italic;">
            No geolocation information available
          </div>
        </div>
      </div>
      <div style="float:right"><vs-button style="width: 100%;" type="line" icon-pack="feather" icon="PlusIcon"
          @click="addTime()" color="#a1afcf">Add Line</vs-button></div>
      <div class="mt-32">
        <vs-button style="width: 100%;" @click="saveData()" v-if="inprogress != true">Save</vs-button>
        <vs-button style="width: 100%;" disabled v-else>Save in progress</vs-button>

      </div>
    </vs-popup>
  </div>
</template>

<script>
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import moment from "moment";
import axios from "@/axios.js";


// Store Module
import moduleEmployeeList from "@/store/employee/moduleDataList.js";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';


export default {
  components: {
    vSelect,
    flatPickr
  },
  data() {
    return {
      inprogress: false,
      selectedn: null,
      selectedtr: {},
      tobedeleted: [],
      popupData: [],
      popupActive: false,
      dataIsCO: false,
      dataIsCM: false,
      dataIsCL: false,
      dataIsFP: false,
      dataIsNM: false,
      OpenedPopupTitle: null,
      datetime: null,
      configdateTimePicker: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i:s',
        time_24hr: true,
        noCalendar: false,
      },
      configDateOnly: {
        enableTime: false,
        dateFormat: 'Y-m-d',
        noCalendar: false,
      },
      rangeStart: null,
      rangeEnd: null,
      month: "",
      year: "",
    };
  },
  computed: {
    operationsData() {
      return this.$store.state.dataListEmployee.attendancespermonth2d;
    },
  },
  methods: {
    nextMonth(value) {
      if (value == -1) {
        if (this.$route.params.month == 1)
          window.location.replace(
            "/web/employees/monthly-report-2d/" +
            (this.$route.params.year - 1) +
            "/12"
          );
        else
          window.location.replace(
            "/web/employees/monthly-report-2d/" +
            this.$route.params.year +
            "/" +
            (this.$route.params.month - 1)
          );
      } else {
        if (this.$route.params.month == 12)
          window.location.replace(
            "/web/employees/monthly-report-2d/" +
            (parseInt(this.$route.params.year) + 1) +
            "/01"
          );
        else
          window.location.replace(
            "/web/employees/monthly-report-2d/" +
            this.$route.params.year +
            "/" +
            (parseInt(this.$route.params.month) + 1)
          );
      }
    },
    async allOffExceptSelected(selectedSwitch) {
      if (selectedSwitch !== 'dataIsCO') this.dataIsCO = false;
      if (selectedSwitch !== 'dataIsCM') this.dataIsCM = false;
      if (selectedSwitch !== 'dataIsCL') this.dataIsCL = false;
      if (selectedSwitch !== 'dataIsFP') this.dataIsFP = false;
      if (selectedSwitch !== 'dataIsNM') this.dataIsNM = false;
      await this.deleteClock(this.popupData[0].id)
      this.popupData = []
    },

    refreshPasPropre() {
      this.$vs.loading();

      let year = this.year
      let month = this.month
      this.$store
        .dispatch("dataListEmployee/fetchattendancepermonth2d", {
          year,
          month,
        })
        .then((response) => {
          this.$vs.loading.close();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async saveData() {
      this.inprogress = true
      let dayoff_type = null
      if (this.dataIsCO == true) dayoff_type = 1
      else if (this.dataIsCM == true) dayoff_type = 2
      else if (this.dataIsCL == true) dayoff_type = 3
      else if (this.dataIsFP == true) dayoff_type = 4
      else if (this.dataIsNM == true) dayoff_type = 5
      if (dayoff_type && this.popupData.length > 0) {
        await this.deleteClock(this.popupData[0].id)
        this.popupData = []
      }

      if (this.popupData.length >= 0 && dayoff_type) {
        var obj = {
          datestart: moment(this.year + "-" + this.month + "-" + this.selectedn + " 12:00:00").utc(),
          datestop: moment(this.year + "-" + this.month + "-" + this.selectedn + " 12:00:00").utc(),
          idperson: this.selectedtr.idperson,
          dayoff_type: dayoff_type
        }
        this.$store
          .dispatch("dataListEmployee/createPresence", obj)
          .then((res) => {
            this.refreshPasPropre();
            this.popupActive = false;
            this.$vs.notify({
              color: "success",
              title: "Attendace Created!",
              text: "The Attendace was successfully added",
            });
          })
      }
      // On EDITE CE QUI A UN ID
      this.popupData.forEach(a => {
        if (a.duration) {
          let splittedDuration = a.duration.split(":");
          if (a.duration && (splittedDuration[0] > 0 || splittedDuration[1] > 0 || splittedDuration[2] > 0)) {
            let dstart = moment(a.datestart, "YYYY-MM-DD HH:mm:ss")
            let dstop = moment(a.datestop, "YYYY-MM-DD HH:mm:ss")
            var obj = {
              id: a.id,
              datestart: moment(dstart).utc(),
              datestop: moment(dstop).utc(),
              idperson: this.selectedtr.idperson,
              dayoff_type: dayoff_type
            }
            // ON CONTINUE
            if (a.id) {
              // ON EDIT
              this.$store
                .dispatch("dataListEmployee/updatePresence", obj)
                .then((res) => {
                  this.$vs.notify({
                    color: "success",
                    title: "Attendace Updated!",
                    text: "The Attendace was successfully updated",
                  });
                  this.refreshPasPropre();
                  this.popupActive = false;
                })
                .catch((err) => {
                  this.refreshPasPropre();
                  this.popupActive = false;
                });

            }
            else {
              // ON AJOUTE
              delete obj.id;
              this.$store
                .dispatch("dataListEmployee/createPresence", obj)
                .then((res) => {
                  this.$vs.notify({
                    color: "success",
                    title: "Attendace Created!",
                    text: "The Attendace was successfully added",
                  });
                  this.refreshPasPropre();
                  this.popupActive = false;
                })
                .catch((err) => {
                  this.refreshPasPropre();
                  this.popupActive = false;
                });
            }
          }
          else {
            this.$vs.notify({
              color: "warning",
              text: "Incorrect date / duration!",
            });
            return
          }
        }
        else {
          this.$vs.notify({
            color: "warning",
            text: "Incorrect date / duration!",
          });
          return
        }
      });
      this.tobedeleted.forEach(e => {
        var obj = {
          id: e,
          idperson: this.selectedtr.idperson
        }
        this.$store
          .dispatch("dataListEmployee/deletePresence", obj)
          .then((res) => {
            this.$vs.notify({
              color: "success",
              title: "Attendance Deleted!",
              text: "The Attendance was successfully deleted",
            });
            this.refreshPasPropre();
            this.popupActive = false;
          })
      })

    },
    saveRange() {
      let dayoff_type = null
      if (this.dataIsCO == true) dayoff_type = 1
      else if (this.dataIsCM == true) dayoff_type = 2
      else if (this.dataIsCL == true) dayoff_type = 3
      else if (this.dataIsFP == true) dayoff_type = 4
      else if (this.dataIsNM == true) dayoff_type = 5

      if (!dayoff_type) {
        this.$vs.notify({ color: "warning", text: "Sélectionnez d'abord un type de congé (CO/CM/CL/FP/NM)." });
        return;
      }
      if (!this.rangeStart || !this.rangeEnd) {
        this.$vs.notify({ color: "warning", text: "Renseignez les dates de début et de fin." });
        return;
      }
      if (moment(this.rangeEnd).isBefore(moment(this.rangeStart))) {
        this.$vs.notify({ color: "warning", text: "La date de fin doit être après la date de début." });
        return;
      }

      this.inprogress = true
      var obj = {
        idperson: this.selectedtr.idperson,
        datestart: this.rangeStart,
        datestop: this.rangeEnd,
        dayoff_type: dayoff_type
      }
      this.$store
        .dispatch("dataListEmployee/createPresenceRange", obj)
        .then((res) => {
          this.refreshPasPropre();
          this.popupActive = false;
          this.$vs.notify({
            color: "success",
            title: "Période appliquée !",
            text: `${res.data.created} jour(s) créé(s), ${res.data.skipped} jour(s) ignoré(s) (déjà remplis).`,
          });
        })
        .catch((err) => {
          this.inprogress = false;
          this.$vs.notify({ color: "danger", text: "Erreur lors de l'application de la période." });
        });
    },
    changeDuration(tr) {
      let dstart = moment(tr.datestart, "DD-MM-YYYY HH:mm:ss")
      let dstop = moment(tr.datestop, "DD-MM-YYYY HH:mm:ss")
      let dura = moment.duration((dstop).diff((dstart)));
      let hours = dura.hours().toString().padStart(2, '0');
      let minutes = dura.minutes().toString().padStart(2, '0');
      let seconds = dura.seconds().toString().padStart(2, '0');
      const ItemIndex = this.popupData.findIndex((p) => p.id === tr.id)
      if (hours || minutes || seconds) this.popupData[ItemIndex].duration = `${hours}:${minutes}:${seconds}`;
    },
    async deleteClock(id) {
      const ItemIndex = this.popupData.findIndex((p) => p.id === id)
      this.popupData.splice(ItemIndex, 1)
      this.tobedeleted.unshift(id)
    },
    addTime() {
      if (this.popupData.length > 0) {
        this.$vs.notify({
          color: "warning",
          text: "You cannot add more than 1 period!",
        });
        return;
      }
      this.allOffExceptSelected('none');

      // Création de la date de début en UTC
      let dt = `${this.year}-${this.month}-${this.selectedn}T05:30:00.000Z`;

      // Convertir la date en UTC puis l'ajuster au fuseau horaire local (UTC+2 ici)
      let dstart = moment(dt).utcOffset(120, true).format("YYYY-MM-DD HH:mm:ss"); // UTC+2 = 120 minutes

      // Ajouter 8 heures et 30 minutes à la date de début pour calculer la date de fin
      let dstop = moment(dstart).add(8, 'hours').add(30, 'minutes').format("YYYY-MM-DD HH:mm:ss");

      // Créer l'objet avec les valeurs ajustées
      let obj = {
        datestart: dstart,
        datestop: dstop,
        duration: '08:30:00'
      };

      // Ajouter l'objet à la popupData
      this.popupData.unshift(obj);
    },
    async sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    activePopup(tr, n, type) {
      this.inprogress = false
      this.selectedn = n;
      this.selectedtr = tr;
      this.tobedeleted = []
      if (n) {
        let clickedDay = `${this.year}-${this.month.toString().padStart(2, '0')}-${n.toString().padStart(2, '0')}`;
        this.rangeStart = clickedDay;
        this.rangeEnd = clickedDay;
        axios.get("/employees/getdetailsforoneperson/" + tr.idperson + "/" + this.year + "/" + this.month + "/" + n)
          .then((response) => {
            this.popupData = [...response.data];
          }).
          then((response) => {
            //this.restructureDate()
            this.OpenedPopupTitle = tr.name + " " + n.toString().padStart(2, '0') + "/" + this.month + "/" + this.year
            this.popupActive = true
            this.dataIsCM = false;
            this.dataIsCO = false;
            this.dataIsNP = false;
            this.dataIsFP = false;
            this.dataIsCL = false;

            if (type === 'CO') this.dataIsCO = true;
            if (type === 'CM') this.dataIsCM = true;
            if (type === 'CL') this.dataIsCL = true;
            if (type === 'FP') this.dataIsFP = true;
            if (type === 'NM') this.dataIsNM = true;

          });

      }
    },
    isWeekEnd(val) {
      let dt = this.year + "-" + this.month + "-" + val
      if (moment(dt).weekday() == 0 || moment(dt).weekday() == 6) return true
      else return false
    },
    isError(val) {
      if (this.formated_time(val) === 'ERROR!' || this.formated_time(val) === 'CO' || this.formated_time(val) === 'CM' || this.formated_time(val) === 'CL' || this.formated_time(val) === 'FP' || this.formated_time(val) === 'NM') { return true }
      else return false
    },
    copyToClipboard(containerid) {
      var range = document.createRange();
      let containerNode = document.getElementById(containerid);

      // Stocker le contenu original
      let originalContent = containerNode.innerHTML;

      // Remplacer les "+" par des espaces ou les supprimer
      let modifiedContent = originalContent.replace(/\+/g, ''); // Pour supprimer les "+" simplement
      containerNode.innerHTML = modifiedContent;

      // Sélectionner et copier le contenu modifié
      range.selectNode(containerNode);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      window.getSelection().removeAllRanges();

      // Restaurer le contenu original
      containerNode.innerHTML = originalContent;
      this.$vs.notify({
        title: "Copy",
        text: "Copy to Clipboard",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success",
        position: "bottom-right",
        time: 4000,
      });
    },
    writeDateTitle() {
      return moment("01-" + this.month + "-" + this.year, "DD-MM-YYYY").format("MMM YYYY")
    },
    // Nom complet (roumain) d'un code de congé, pour l'infobulle au survol.
    leaveFullName(duration) {
      const map = {
        CO: 'Concediu de odihnă',
        CM: 'Concediu medical',
        CL: 'Concediu legal',
        FP: 'Concediu fără plată',
        NM: 'Nemotivat',
      }
      return map[duration] || ''
    },
    formated_time(duration) {
      if (duration === 'CO') return "CO"
      if (duration === 'CM') return "CM"
      if (duration === 'CL') return "CL"
      if (duration === 'FP') return "FP"
      if (duration === 'NM') return "NM"
      if (duration) {
        if (duration.includes("day") || duration.includes("days")) {
          return "ERROR!";
        }
        try {
          let time = moment.duration(duration);
          time.subtract(30, 'minutes');
          let days = Math.floor(time.asDays());
          let hours = time.hours() + days * 24;
          let minutes = time.minutes();
          return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0')
        } catch (error) {
          console.error(error);
          return "Invalid Time";
        }
      }
    },
    formated_time_total(duration) {
      try {
        let time = moment.duration(duration);
        let days = Math.floor(time.asDays());
        let hours = time.hours() + days * 24;
        let minutes = time.minutes();
        return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0')
      } catch (error) {
        console.error(error);
        return "Invalid Time";
      }

    },
  },
  mounted() {

  },
  created() {
    this.$vs.loading();

    if (localStorage.getItem("login-roles").toLowerCase().includes("admin")) {
      this.displayExport = true;
    }
    if (!moduleEmployeeList.isRegistered) {
      this.$store.registerModule("dataListEmployee", moduleEmployeeList);
      moduleEmployeeList.isRegistered = true;
    }
    let year = this.$route.params.year;
    let month = this.$route.params.month;
    this.year = this.$route.params.year;
    this.month = this.$route.params.month;
    this.$store
      .dispatch("dataListEmployee/fetchattendancepermonth2d", {
        year,
        month,
      })
      .then((response) => {
        this.$vs.loading.close();
      })
      .catch((err) => {
        console.error(err);
      });
  },
};
</script>
<style lang="scss">
.month-navigation-header {
  color: white;
  text-align: center;
}

.month-navigation-button {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 1.5em;
  margin: 0 10px;
  transition: color 0.3s;
}

.month-navigation-button:hover {
  color: #ccc;
}

body {
  overflow-x: scroll;
}

table {
  width: 100%;
  border-collapse: collapse;
  overflow-x: scroll;
}

th,
td {
  padding: 8px;
  text-align: left;
  border: 1px dashed #c0c0c0;
}

.sticky-header {
  position: sticky;
  top: 0;
  background: #666;
  color: #fff;
  z-index: 2;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.4);
  /* Ajout de l'ombre */
}

.sticky-column {
  position: sticky;
  left: 0;
  background: #ddd;
  color: #444;
  z-index: 1;
}

.td_name {
  font-weight: bold;
  min-width: 210px;
  box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.2);
  /* Ajout de l'ombre */
}

.small {
  min-width: 120px;
  width: 180px;
}

.td_day {
  min-width: 120px;
  width: 180px;
}

.td_sum {
  min-width: 110px;
  width: 110px;
}

.likebtn {
  padding: 3px;
  border-radius: 20px;
  background-color: #3498db;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}

.likebtn:hover {
  background-color: #2980b9;
}

.likebtnred {
  background-color: red;
  color: white;
  border-radius: 20px;
  padding: 0px 10px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
}

.likebtngray {
  background-color: #ddd;
  border-radius: 20px;
  padding: 0px 10px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
}

.likebtngray:hover {
  background-color: #bbb;
}

#thistable tr:nth-of-type(odd) {
  background-color: #eee;
}

#thistable tr:hover {
  background-color: #666;
  color: #fff;
}

.likebtnheadpopupduration,
.likebtnpopupduration {
  display: inline-block;
  width: 100px;
  border-radius: 10px;
}
</style>
